import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { Link } from "react-scroll";
import { socialLinks, personalInfo } from "../../data/portfolioData";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <span className="footer__logo">
            &lt;{personalInfo.name.split(" ")[0]} /&gt;
          </span>
          <div className="footer__socials">
            <a href={socialLinks.github} target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <Link to="contact" smooth={true} offset={-70} duration={500} style={{ cursor: "pointer" }} aria-label="Email">
              <FaEnvelope />
            </Link>
          </div>
        </div>
        <div className="footer__divider" />
        <p className="footer__copy">
          &copy; {new Date().getFullYear()} {personalInfo.name}. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
